import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Question } from 'src/app/models/question.model';
import { environment } from 'src/environment';

@Injectable({
  providedIn: 'root'
})
export class CollectionQuestionApiService {
  #httpservice = inject(HttpClient);
  //#baseUrl = inject(ConfigurationService).config.serverUrl;
  #baseUrl = environment.apiUrl;
  #specBaseUrl = `${this.#baseUrl}/collectionQuestions`


  getAll = () => {
    return this.#httpservice.get<Question[]>(`${this.#specBaseUrl}/getCollectionQuestions`);
  }
  deleteById = (id: number) => {
    return this.#httpservice.get<Question[]>(`${this.#specBaseUrl}/deleteQuestionById/${id}`);
  }
  // xx = (questionId: number) => {
  //   return this.#httpservice.get<Question>(`${this.#specBaseUrl}/getCollectionQuestionById/${questionId}`)
  // }
  createCollectionQuestion = (question: Question) => {
    return this.#httpservice.post<number>(`${this.#specBaseUrl}/createCollectionQuestion`, question)
  }
  update = (question: Question) => {
    return this.#httpservice.post<number>(`${this.#specBaseUrl}/updateCollectionQuestion`, question)
  }
}
